// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"c0d57703","135":"a29d37aa","310":"53af26cb","593":"66ff3ac9","785":"65d46819"}[chunkId] + ".chunk.js";
};